import React, { useState } from 'react';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaPaperPlane,
} from 'react-icons/fa';
import './contact.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    category: 'Female Model',
    subject: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        category: 'Female Model',
        subject: '',
        message: '',
      });
    }, 4000);
  };

  return (
    <div className="contact-page">
      {/* Header Banner */}
      <div className="contact-hero">
        <span className="contact-subtitle">GET IN TOUCH</span>
        <h1 className="contact-title">Contact Our Studio</h1>
        <p className="contact-desc">
          Have an upcoming campaign, audition query, or looking to cast models for your brand? Reach out to our casting directors and studio producers below.
        </p>
      </div>

      <div className="contact-container">
        {/* Contact Info Cards */}
        <div className="contact-info-grid">
          <div className="info-card">
            <div className="info-icon">
              <FaMapMarkerAlt />
            </div>
            <h3>Our Studio</h3>
            <p>104, High Street Park, Lower Parel,</p>
            <p>Mumbai, Maharashtra 400013</p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <FaPhoneAlt />
            </div>
            <h3>Call Us</h3>
            <p>+91 98765 43210</p>
            <p>+91 22 2490 1234</p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <FaEnvelope />
            </div>
            <h3>Email Directly</h3>
            <p>castings@luxurystudios.com</p>
            <p>enquiries@luxurystudios.com</p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <FaClock />
            </div>
            <h3>Working Hours</h3>
            <p>Mon - Sat: 10:00 AM - 7:00 PM</p>
            <p>Sunday: Closed</p>
          </div>
        </div>

        {/* Split Section: Form & Map */}
        <div className="contact-split">
          {/* Inquiry Form */}
          <div className="contact-form-wrap">
            <h2>Send Us A Message</h2>
            <p className="form-subtext">
              Fill out this form and our booking manager will respond within 24 hours.
            </p>

            {submitted && (
              <div className="form-success-alert">
                Thank you! Your inquiry has been sent successfully.
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Your Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter full name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="name@example.com"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 00000"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Inquiry Category</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                  >
                    <option value="Female Model">Female Models</option>
                    <option value="Male Model">Male Models</option>
                    <option value="Female Child Model">Female Child Models</option>
                    <option value="Male Child Model">Male Child Models</option>
                    <option value="Studio Booking">Studio Rental</option>
                    <option value="Commercial Shoot">Commercial Campaign</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Campaign / Casting query"
                />
              </div>

              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Provide project details, dates, or model requirements..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="form-submit-btn">
                <FaPaperPlane /> Send Inquiry
              </button>
            </form>
          </div>

          {/* Embedded Google Map */}
          <div className="contact-map-wrap">
            <iframe
              title="Studio Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.1979313271775!2d72.825838!3d18.991206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ce8c946be4db%3A0xe21288cbe009214b!2sLower%20Parel%2C%20Mumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;